'use client';

import DOMPurify from 'dompurify';
import { useMemo } from 'react';

import { cn } from '@/lib/utils';

interface HtmlRendererProps {
  html: string | null | undefined;
  className?: string;
}

export function HtmlRenderer({ html, className }: HtmlRendererProps) {
  const sanitized = useMemo(() => {
    if (!html) return null;
    const processedHtml = html
      .replace(/<p><\/p>/g, '<p>&nbsp;</p>')
      .replace(/<p><br\s*\/?><\/p>/g, '<p>&nbsp;</p>');
    return DOMPurify.sanitize(processedHtml);
  }, [html]);

  if (!sanitized) {
    return null;
  }

  return (
    <div
      className={cn(
        'prose prose-sm dark:prose-invert max-w-none text-foreground prose-headings:font-display prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-foreground prose-p:text-foreground/90 prose-strong:text-foreground prose-a:text-primary [&_ul]:list-disc [&_ol]:list-decimal [&_li]:ml-4 [&_li]:pl-0.5 [&_p]:leading-relaxed [&_p+p]:mt-4',
        className
      )}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
